import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import PermContactCalendarIcon from '@mui/icons-material/PermContactCalendar';
import { Typography, Table, TableBody, TableCell, TableContainer, TableRow } from "@mui/material";

import { RootState } from "../../../shared/state/root-reducer";
import { formatNumberToUSD } from "@finpay-development/shared-platform/lib/esm/shared/calculators";

export function SidebarFinancialSummary() {

	const estimate = useSelector((state: RootState) => {
		return state.estimatorContext.selectedEstimate
	})

  const financialSummary = estimate?.summary

  const totalCharges = formatNumberToUSD(financialSummary?.totalAdjustedCharges)
  const coveredCharges = formatNumberToUSD(financialSummary?.netPFR)
  const unCoveredCharges = formatNumberToUSD(financialSummary?.unCoveredCharges) 
  const totalSurcharges = formatNumberToUSD(financialSummary?.totalSurcharges) 
  const eiv = formatNumberToUSD(estimate?.riskAssessment?.estInsVal)
  
  const showSurcharges = Boolean(financialSummary?.totalSurcharges && financialSummary?.totalSurcharges > 0 )
  const showEiv = estimate?.riskAssessment?.estInsVal != null

  const summaryExists = estimate?.facilityLevelOfCare && estimate?.facilityLevelOfCare?.length > 0 && estimate?.summary
	return (
		<>
			{summaryExists ? (
				<>
					<TableContainer>
						<Table size="small" aria-label="a dense table">
							<TableBody>
									<TableRow >
										<TableCell component="th" scope="row">
										Estimated Adjusted Charges
										</TableCell>
										<TableCell align="right"><strong test-id="side-financial-summary-est-adj-charges">{totalCharges}</strong></TableCell>
									</TableRow>
									<TableRow >
										<TableCell component="th" scope="row">
										PFR for Covered Services
										</TableCell>
										<TableCell align="right"><strong test-id="side-financial-summary-pfr-covered-services">{coveredCharges}</strong></TableCell>
									</TableRow>
									<TableRow style={showSurcharges || showEiv ? {} : {borderBottom: "none"}}>
										<TableCell component="th" scope="row" >
										PFR for Uncovered Services
										</TableCell>
										<TableCell align="right"><strong test-id="side-financial-summary-pfr-uncovered-services">{unCoveredCharges}</strong></TableCell>
									</TableRow>
									{showSurcharges && (
									<TableRow style={showEiv ? {} : {borderBottom: "none"}}>
										<TableCell component="th" scope="row" >
										Admission Assessment
										</TableCell>
										<TableCell align="right" ><strong test-id="side-financial-summary-admin-assessment">{totalSurcharges}</strong></TableCell>
									</TableRow>
									)}
									{showEiv && (
									<TableRow style={{borderBottom: "none"}}>
										<TableCell component="th" scope="row" >
										Estimated Insurance Value
										</TableCell>
										<TableCell align="right" ><strong test-id="side-financial-summary-eiv">{eiv}</strong></TableCell>
									</TableRow>
									)}
							</TableBody>
						</Table>
					</TableContainer>
				</>
      ) : (
				<Typography 
					align="center"
					style={{
						color: "#B4BECC",
						fontSize: "10pt"
					}}>
					<PermContactCalendarIcon /><br/>Add levels of care to estimate patient financial responsibility
				</Typography>
      )}
		</>
	)
	

} 